var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon, _path9, _polygon2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _polygon3, _path24, _path25, _polygon4, _path26, _polygon5, _polygon6, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDealHend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 823.85,
    height: 516.21,
    viewBox: "0 0 823.85 516.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 287.17,
    y1: 289.57,
    x2: 181.59,
    y2: 252.97,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 517.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 505.87,
    y1: 267.58,
    x2: 553.18,
    y2: 237.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 486.86,
    y1: 470.04,
    x2: 508.25,
    y2: 470.04,
    gradientTransform: "translate(-1.45 -304.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 499.82,
    y1: 455.09,
    x2: 462.11,
    y2: 517.83,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 467.61,
    y1: 440.42,
    x2: 512.91,
    y2: 440.42,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 386.42,
    y1: 585.25,
    x2: 409.95,
    y2: 576.08,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 292.09,
    y1: 221.62,
    x2: 333.76,
    y2: 322.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 315.38,
    y1: 439.24,
    x2: 327.77,
    y2: 443.09,
    gradientTransform: "translate(0 -307.34)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 414.59,
    y1: 568.67,
    x2: 391.07,
    y2: 624.14,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 403.86,
    y1: 583.92,
    x2: 398.44,
    y2: 603.61,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 513.68,
    y1: 616.03,
    x2: 541.91,
    y2: 616.03,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 499.09,
    y1: 354.33,
    x2: 497.69,
    y2: 94.45,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 518)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 481.34,
    y1: 354.42,
    x2: 479.94,
    y2: 94.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 300.51,
    y1: 366.08,
    x2: 295.81,
    y2: 323.47,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 124.35,
    y1: 286.49,
    x2: 143.68,
    y2: 280.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 144.69,
    y1: 283.62,
    x2: 132.12,
    y2: 283.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 152.34,
    y1: 266.54,
    x2: 85.04,
    y2: 315.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 110.8,
    y1: 146.34,
    x2: 30.83,
    y2: 313.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -121.91,
    y1: 593.8,
    x2: 381.92,
    y2: 795.33,
    gradientTransform: "translate(0 -252.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#00272e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69b9eb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 266.13,
    y1: 603.46,
    x2: 266.53,
    y2: 603.46,
    gradientTransform: "translate(0 -307.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69b9eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 288.46,
    y1: 788.02,
    x2: 247.71,
    y2: 806.01,
    gradientTransform: "translate(0 -307.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 353.1,
    y1: 787.21,
    x2: 317.49,
    y2: 811.07,
    gradientTransform: "translate(0 -307.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 518.26,
    y1: 782.03,
    x2: 546.89,
    y2: 803.69,
    gradientTransform: "translate(0 -307.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 430.51,
    y1: 780.68,
    x2: 486.31,
    y2: 808.95,
    gradientTransform: "translate(0 -307.34)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7. deal_handshakes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M823.65,366.07a116.83,116.83,0,0,1-12,45.94c-11.58,23-29.6,41.79-50.93,56.32a205.68,205.68,0,0,1-37.92,20.23,230.24,230.24,0,0,1-22.4,7.84c-46,13.46-94.54,14.12-142.42,14.68L221,515h0l-44.32.51c-14.1.17-28.47.27-42.69-.51-27.13-1.46-53.76-6.09-77.11-19.42A102.67,102.67,0,0,1,26,468.33C10.17,447.44,1.61,420.8,1.2,394.25v-2.79C1.37,365.55,9.37,340,26,320.05c1.06-1.26,2.14-2.51,3.27-3.72,2.35-2.54,4.92-5,7.62-7.46,17.19-15.51,39.89-29.41,50.18-49.39,18.1-35.16-4.47-49.51-7.44-84-5-58,53.72-124.65,101.42-151.26C232.34-4.46,296.94-7.9,351,15.11c57.2,24.36,110.58,77.41,170.92,62.45,19.4-4.81,37.22-16.65,57.21-17,36.94-.71,62.58,36.86,74.08,72s17.74,74.8,45.08,99.67c19.62,17.84,46.67,24.55,70.43,36.4a115.78,115.78,0,0,1,20.39,12.65c14,11.06,23.62,26.07,29.16,42.75A114.34,114.34,0,0,1,823.65,366.07Z",
    transform: "translate(0 0)",
    fill: "#e5c15c",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.93,468.66a215,215,0,0,1-60.32,28.06c-43,12.59-88.21,14-133,14.56l-9.39.12L434.5,512.85l-62.84.74-139.87,1.63-10.61.12h0l-44.33.52c-14.1.17-28.46.26-42.69-.52C107,513.92,80.37,509.29,57,496A102.58,102.58,0,0,1,26.26,468.7Z",
    transform: "translate(0 0)",
    fill: "#e5c15c",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.57,491.12c.29,4.17-2.67,8.2-1.83,12.29,1.24,6,8.09,5,14.23,4.55,14.92-1.22,34-3.5,48.53-7.25,13.45-3.48,23.24-6.84,36.06-11,1-.33.69-3.17.74-4.22.08-1.39-1.76-1.91-3.15-2-12.68-.41-25.5,0-37.94-2.5-5.59-1.14-11.07-2.88-16.74-3.53-7-.79-14,.07-21-.46-5.07-.39-17.42-5.94-22.13-3.66C614.28,476.83,624.22,486.08,624.57,491.12Z",
    transform: "translate(0 0)",
    fill: "#000405",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.78,494.88c14.65,4.11,26.5,12.81,39.4,19.55q-69.94.8-139.87,1.62a63.89,63.89,0,0,1,13-9.58c15.33-8.58,33.34-10.56,50.8-12.38C306.31,492.81,318.92,491.56,330.78,494.88Z",
    transform: "translate(0 0)",
    fill: "#000405",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.57,507.2a7.39,7.39,0,0,1-1.66,3.62,6.59,6.59,0,0,0-.78,1.3l-9.39.12L433,513.66a36.68,36.68,0,0,0,6.06-5.95c2.58-3.2,4.64-6.83,7.64-9.61,8.86-8.22,22.89-6.69,34.37-3,3.49,1.14,7,2.44,10.68,2.39,6.52-.08,12.12-4.32,18-7.24,18.47-9.22,42.92-4.28,56.36,11.39C567.43,503.26,568.74,505.14,568.57,507.2Z",
    transform: "translate(0 0)",
    fill: "#000405",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M502.57,367,479.7,479.51l-15.37-1.76-1.77-.21s4.4-33.34,6.3-80.89c1.25-31.5,6.64-57.22,9.22-78.6a97.33,97.33,0,0,1,4-17.34c3.12-9.46,7.87-18.31,13.91-17.4,13.34,2,30.91,13.53,33.23,20.75C533.26,316.66,502.57,367,502.57,367Z",
    transform: "translate(0 0)",
    fill: "#25233a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M486.58,301S476.33,380.41,476,405.18s-10.52,72.36-10.52,72.36l-1.18.21-1.77-.21s4.4-33.34,6.3-80.89c1.25-31.5,6.64-57.22,9.22-78.6a97.33,97.33,0,0,1,4-17.34A19.62,19.62,0,0,1,486.58,301Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M555,479.33H538v-.1c-.46-2.29-9-44.59-21.07-75.23-9-22.85-13.35-69.39-15-93.21-.66-9-.92-14.76-.92-14.76s34.52-10.19,39-5.67,9.57,25,9.57,25-11.82,81.1-4.3,86.6S555,479.33,555,479.33Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M286,155.19s-25.14,7.75-35.32,80.31c-3.68,26.16,19.72,72.37,19.72,72.37Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286,155.19s-25.14,7.75-35.32,80.31c-3.68,26.16,19.72,72.37,19.72,72.37Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M267.64,298.81a9.83,9.83,0,0,0-11.28,11.32c1.92,11.34,5.58,27.08,12,36C279.2,361.06,294,381.66,294,381.66l15.3,105,18.87-2.55L328,383.49l-21.3-78.23Z",
    transform: "translate(0 0)",
    fill: "#25233a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M306.65,305.26l-2.45,87.4-40.45,94.07L250.2,481l-3.94-1.69,22.4-88.2s-8.72-24-15.14-41.5c-6.16-16.79,2.22-50.06,2.92-52.74v-.18Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M474.15,249.36,424.24,274.1l-9.32-11.87h0l-2.39-3.06L455.17,236s14.65-32.57,17.83-47.54c.61-2.78,1.22-5,1.79-6.91,1.11-3.47,11.7-15.73,15.26-16.46s-.45,10.21,1.92,13a22,22,0,0,1,3.8,13C496.18,200.39,474.15,249.36,474.15,249.36Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M540,278.33s-24.79,29.79-53.37,22.7a39,39,0,0,1-5.76-1.94,10,10,0,0,1-5.24-13.1v-.06c2.76-6.26,2.84-15.31,2.59-23.66-.58-19.21-5.44-40-5.8-48.65-.24-5.53.65-13.36,2.28-21.18,2.87-13.9,8-27.75,13.31-28.55,15.64-2.41,21,1.85,21,1.85l26.7,15.51C549,195.11,542.54,216.87,540,278.33Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "500.81 199.87 507.64 210.87 488.73 230 484.84 233.94 505.39 164.29 505.47 157.32 508.08 159.99 508.08 160 511.5 163.5 512.81 192.34 500.81 199.87",
    fill: "#e5c15c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M537.46,216.3l-2.9,75.09s-40.8,19.39-46.19-2.4c-4.17-16.84,6.5-36.05,6.5-36.05Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "497.28 257.94 485.01 307.35 560.83 322.91 571.73 274.57 497.28 257.94",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M506,146.3c0,.22-.27,11.41-.66,18.53-.28,5.51-2.86,9.39-6.8,13.23a24.33,24.33,0,0,1-8.09,5.58,4.29,4.29,0,0,1-5.5-2.53h0a4.36,4.36,0,0,1-.11-2.6c.39-1.48.78-3.2,1.08-5,.64-3.71.92-7.73-.09-10.57a2.81,2.81,0,0,0-.1-.31c-.6-1.47,0-3.07,1.36-4.68,1.91-2.27,5.25-4.57,8.58-6.51A101.26,101.26,0,0,1,506,146.3Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M488.1,172.75a9.25,9.25,0,0,1-2.16.76c.64-3.71.92-7.73-.09-10.57l1.26-5,.95-3.72,7.63-2.79,7.73-2.82C501.56,162.37,494.2,169.86,488.1,172.75Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M486,107.2a22,22,0,0,0-20.61,23.31h0a12.1,12.1,0,0,0,.17,1.69A74.3,74.3,0,0,0,472.38,158c7.19,12.2,25.25,2.1,28.1-2.94s13.6-27.84,9.06-34.31C506.54,116.25,497.72,106.66,486,107.2Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M466.88,98.6l3.72,1.9a14,14,0,0,0-11.47,5.58,18.33,18.33,0,0,0-5.35,12.83l6.31-3s-.47,7.79,11.49,8.36,24.62,1,24.62,1l-4.06-5.61s7.44,3,8.74,5.71a90,90,0,0,1,2.56,13.42s2.95-7.69,4.18-6-1.28,8.65-2.83,10.18-1.29,6.11-1.43,6.49,7.41-5.91,7.74-8.07,7.81-24,2.9-28.56l3-.23a14,14,0,0,0-5.87-2.26S491.43,84.66,466.88,98.6Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M389.14,269.41A58.67,58.67,0,0,1,399.81,262a35.16,35.16,0,0,1,9.29-1.92s.52,4.37-2,4.66-4.62,4.12-4.62,4.12,16.17,6.62,18.4,6,1.79,2.6-2.3,2.39-5.09,5.51-7.92,5.43-7.31,1.67-11.47,1.82a43.18,43.18,0,0,1-12.26-2.86Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M326.56,223,313,299.22s-4.68,14.59-28.9,12.41A38.78,38.78,0,0,1,260.49,301h0l-.39-.37-.27-.28a47.06,47.06,0,0,1-10.67-16.16S264.72,176.66,281.06,158c1.63-1.86,3.26-2.85,4.9-2.76A28.9,28.9,0,0,1,298.44,160,61.14,61.14,0,0,1,326.56,223Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M301.07,220.45l-17,91.17s26.05,3.58,28.9-12.4l8-46.37Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-7)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M286,155.19s2.59-19.61,3.63-32.36,5.2-29.83,26.6-27.64,21.47,34.54,15.56,48.08S318,156.42,318,156.42s-10.66-2.32-10.26,10.5Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M293.9,92.48a24,24,0,0,0-6.51,10.94,57.54,57.54,0,0,0-1.94,10.33l2.18-2.39a159.79,159.79,0,0,1-1.33,17.89,97.18,97.18,0,0,0-1,16.7l4-.2,5,6.14,5.52-3.74L304,146l3.7-9.14a5.14,5.14,0,0,1-1.8-6c1.36-3.73,4.74-4.59,5.53-2.39a43.3,43.3,0,0,1,1,8.34l5.9-16.71s3.7-5.19,6.94-1.62a17.29,17.29,0,0,0,7.14,4.76l-2-5.52,5.35,1.37-.42-6.38,4,2.79s1.75-10.33-1.64-14.91S320.83,77.66,293.9,92.48Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M389.59,267.34l-2.71,14.32-.73,3.85-48.81-3.64c-13.51-1.16-26.77-10.4-28.45-23.91L292,198.33a15.14,15.14,0,0,1,16.66-19.48,17.39,17.39,0,0,1,14,11.93l10.63,53.37a16.65,16.65,0,0,0,12.53,13Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M414.92,262.22l-6.8,2.12s-8.5.76-11.33,3.18-1.25,3.51-1.25,3.51,9-1.32,10.94-.57,11.43,4.52,14.43,4.47,3.33-.83,3.33-.83Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-9)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M394.41,280a4.3,4.3,0,0,1,3.73-1,.73.73,0,0,1,.39.2.85.85,0,0,1,0,.79,13.45,13.45,0,0,1-2.12,4.23c1.06-.36,1.55-1.54,2.22-2.43a5.6,5.6,0,0,1,4.3-2.22,1,1,0,0,1,.58.12c.41.28.23.92,0,1.37-.42.84-.83,1.69-1.25,2.54a25.24,25.24,0,0,1,3.66-4.2,2.75,2.75,0,0,1,1.2-.75,1,1,0,0,1,1.2.53,1.28,1.28,0,0,1,0,.82,9.26,9.26,0,0,1-1.5,3.21,15.51,15.51,0,0,1,3.14-3.71.83.83,0,0,1,.72-.29.61.61,0,0,1,.35.3c.42.7,0,1.59-.44,2.29-.81,1.29-1.84,2.67-3.35,2.9a4.2,4.2,0,0,0-1,.18,3.49,3.49,0,0,0-.65.43,3.24,3.24,0,0,1-3.55.08,4.42,4.42,0,0,1-4.86-.08,1,1,0,0,0-1.2-.09,3.32,3.32,0,0,1-3.68-1.09C391.4,282.85,393.42,280.86,394.41,280Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-10)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M540.94,304.89l-16.7-5.77-.57-.2,12.17-39.12s-16-44-18.66-57.47a37.74,37.74,0,0,1-.12-13.57,11.73,11.73,0,0,1,9.2-9.55,11.36,11.36,0,0,1,7.66,1,50.33,50.33,0,0,1,6,3.66,8,8,0,0,1,3.07,4.58c3,12.32,15.07,62.58,15.52,67.35C559,261.27,540.94,304.89,540.94,304.89Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M519.31,302.44c-.82.78-1.6,2.18-.73,2.92.21.18.5.28.67.5.42.53-.1,1.27-.58,1.74l-4,3.89c-1.48,1.43-3.09,3.22-2.75,5.25a4.13,4.13,0,0,0,2.9,3.05,8.31,8.31,0,0,0,4.37-.05,2.15,2.15,0,0,0,1.19,2.05,6.49,6.49,0,0,0,2.44.6,18.2,18.2,0,0,0,7.35-.2c.18.27.36.53.55.79,3.16-.56,4.88-3.94,6-6.94s2.26-6.34,3.22-9.57a2.15,2.15,0,0,0,.09-1.37,2.2,2.2,0,0,0-1.42-1.07c-3.82-1.45-7.63-2.93-11.46-4.36C523.61,298.35,522,299.93,519.31,302.44Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-11)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "500.81 199.87 507.64 210.87 488.73 230 484.84 233.94 505.39 164.29 505.47 157.32 508.08 159.99 508.08 160 511.5 163.5 512.81 192.34 500.81 199.87",
    fill: "#e5c15c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M485.94,173.51l-2.55,12,1.45,48.42,18.63-63.13-8,5.06c-.43.27-.87.52-1.33.75a5.92,5.92,0,0,1-7.95-2.63h0c-.08-.16-.15-.32-.22-.49Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M486.06,163.84l-8.31,15.57,2.76,6.5L476,195.66l8.81,38.27s-2.41-46.78,1.1-60.44C485.94,173.51,487.1,167,486.06,163.84Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "500.81 199.87 507.64 210.87 488.73 230 484.84 233.94 505.39 164.29 505.47 157.32 508.08 159.99 508.08 160 511.5 163.5 512.81 192.34 500.81 199.87",
    fill: "url(#linear-gradient-12)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M486.06,163.84l-8.31,15.57,2.76,6.5L476,195.66l8.81,38.27s-2.41-46.78,1.1-60.44C485.94,173.51,487.1,167,486.06,163.84Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-13)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "285.32 151.91 309.87 164.12 316.51 176.99 281.08 157.93 285.32 151.91",
    fill: "#e5c15c"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "285.32 151.91 309.87 164.12 316.51 176.99 281.08 157.93 285.32 151.91",
    fill: "url(#linear-gradient-14)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M219.7,321.21v195H198.23V427.75H4.57A130.78,130.78,0,0,1,0,395.42v-2.76c.17-25.9,8.16-51.52,24.81-71.41Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M242.61,310v11.18H24.81c1.05-1.26,2.14-2.51,3.26-3.72,2.36-2.54,4.92-5,7.63-7.46Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M124.15,245.66c-2.46-2.36-5.4-4.16-8-6.32-.92-.76-1.89-1.78-1.71-3a2.5,2.5,0,0,1,2-1.87,7.52,7.52,0,0,1,2.91.18l-5.6-6.3c-.52-.59-1.08-1.4-.7-2.09s1.45-.65,2.19-.3a4.71,4.71,0,0,0,2.26.81c-2-2.81-4.54-5.1-6.67-7.77s-3.84-6-3.52-9.36a2.18,2.18,0,0,1,.49-1.34c.64-.64,1.72-.37,2.55,0a26,26,0,0,1,13.33,13.16,23.91,23.91,0,0,1-1.1-8.89,2.38,2.38,0,0,1,.76-1.88c1-.69,2.32.5,2.9,1.61,3.94,7.67,1.19,17,2.8,25.49a9.32,9.32,0,0,1,3.08-6.13,44,44,0,0,1-.5,13.11c1.23.54,1.13,2.3.82,3.62q-.6,3-1.5,6c-2.2-.18-2.24-1.38-2.93-3.15A15.9,15.9,0,0,0,124.15,245.66Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M141.78,219.52c2.07-2.35,4.55-4.58,7.62-5.22.93,1.79,0,4-1.29,5.57s-2.89,3-3.54,4.86a19.71,19.71,0,0,1,10.35-6.47,5.83,5.83,0,0,1,4.38.25,1.67,1.67,0,0,1,.82,1c.24,1.1-1.16,1.76-2.26,2a34.49,34.49,0,0,0-19.17,13.15,24.13,24.13,0,0,1,15.21-3.33c.92.11,2,.39,2.34,1.24.53,1.26-.9,2.46-2.2,2.89-5,1.66-11.26-.11-15.3,3.31a8.6,8.6,0,0,1,6.14,1.7c1.41,1.07,2.45,3.26,1.21,4.52a3.63,3.63,0,0,1-3,.68c-2.89-.25-6.45-.73-8.11,1.65-.91,1.31-.84,3-1.18,4.6-.27,1.27-1.32,3.52-2.7,2.28-.92-.83-.56-3.73-.56-4.83a46,46,0,0,1,11.22-29.82Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M124.15,245.66c-2.46-2.36-5.4-4.16-8-6.32-.92-.76-1.89-1.78-1.71-3a2.5,2.5,0,0,1,2-1.87,7.52,7.52,0,0,1,2.91.18l-5.6-6.3c-.52-.59-1.08-1.4-.7-2.09s1.45-.65,2.19-.3a4.71,4.71,0,0,0,2.26.81c-2-2.81-4.54-5.1-6.67-7.77s-3.84-6-3.52-9.36a2.18,2.18,0,0,1,.49-1.34c.64-.64,1.72-.37,2.55,0a26,26,0,0,1,13.33,13.16,23.91,23.91,0,0,1-1.1-8.89,2.38,2.38,0,0,1,.76-1.88c1-.69,2.32.5,2.9,1.61,3.94,7.67,1.19,17,2.8,25.49a9.32,9.32,0,0,1,3.08-6.13,44,44,0,0,1-.5,13.11c1.23.54,1.13,2.3.82,3.62q-.6,3-1.5,6c-2.2-.18-2.24-1.38-2.93-3.15A15.9,15.9,0,0,0,124.15,245.66Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-15)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.78,219.52c2.07-2.35,4.55-4.58,7.62-5.22.93,1.79,0,4-1.29,5.57s-2.89,3-3.54,4.86a19.71,19.71,0,0,1,10.35-6.47,5.83,5.83,0,0,1,4.38.25,1.67,1.67,0,0,1,.82,1c.24,1.1-1.16,1.76-2.26,2a34.49,34.49,0,0,0-19.17,13.15,24.13,24.13,0,0,1,15.21-3.33c.92.11,2,.39,2.34,1.24.53,1.26-.9,2.46-2.2,2.89-5,1.66-11.26-.11-15.3,3.31a8.6,8.6,0,0,1,6.14,1.7c1.41,1.07,2.45,3.26,1.21,4.52a3.63,3.63,0,0,1-3,.68c-2.89-.25-6.45-.73-8.11,1.65-.91,1.31-.84,3-1.18,4.6-.27,1.27-1.32,3.52-2.7,2.28-.92-.83-.56-3.73-.56-4.83a46,46,0,0,1,11.22-29.82Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-16)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M143.88,309.92l-11.44.06-11.32,0C96.22,295.22,125,265.2,125,265.2s1.14-4.68-.35-7.63a4.18,4.18,0,0,0-1.55-1.73c-3.67-2.2,1.45-3.07,1.45-3.07h15.36s5.26.44,1.31,3.21-1.75,9.22-1.75,9.22C170.2,299.37,143.88,309.92,143.88,309.92Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.27,309.08a7.83,7.83,0,0,1-.83.9l-11.32,0C96.22,295.22,125,265.2,125,265.2s1.14-4.68-.35-7.63c5-.38,7.41,6.07,6.74,10.17-.51,3.16-1,6.33-1.55,9.49a28.63,28.63,0,0,0-.5,9c.62,4,2.9,7.53,4.39,11.29S135.76,305.88,133.27,309.08Z",
    transform: "translate(0 0)",
    opacity: 0.51,
    fill: "url(#linear-gradient-17)",
    style: {
      isolation: "isolate"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M219.7,321.21,107.82,353A145.25,145.25,0,0,0,17.6,427.75H4.6A130.81,130.81,0,0,1,0,395.42v-2.76c.17-25.9,8.16-51.52,24.81-71.41Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 198.23,
    y: 427.75,
    width: 10.26,
    height: 88.3,
    opacity: 0.61,
    fill: "url(#linear-gradient-19)",
    style: {
      isolation: "isolate"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M822.44,367.23a117,117,0,0,1-12,45.94,132.11,132.11,0,0,1-8.9,15.09c-11.08,16.28-25.57,30-42,41.24a206.24,206.24,0,0,1-37.92,20.22l-26.51-4.89-50.81-9.37c-2.49-.46-4.9-.75-7.18-1-9.37-1.06-16.66-1.58-19.41-11.09-3.41-11.71,0-29.63,0-41.91,0-21.34,2.23-46.75,20.81-57.23,15.42-8.68,35-2.55,52.21-6.57a9.9,9.9,0,0,0,4.54-2c2-1.85,2.31-4.85,2.36-7.57.43-20.65-6.47-43.81,5.87-60.37,9.44-12.66,26.71-16.15,42.43-17.61a141.58,141.58,0,0,1,14.56-.63q3.54,0,7.07.3c16.29,1.26,31.81,6.49,40.09,19.9,4.43,7.16,6,15.66,7.48,23.95.67,3.83,1.34,7.69,2,11.55C819.33,339,821.33,353.15,822.44,367.23Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M822.44,367.23a117,117,0,0,1-12,45.94,132.11,132.11,0,0,1-8.9,15.09c-6.09,2.59-13.42,2.56-20.21,2.66a227.38,227.38,0,0,0-31.91,2.74c-4.74.74-9.68,1.73-13.4,4.77-4.91,4-6.61,10.83-6.88,17.18s.58,12.78-.5,19.05a12.2,12.2,0,0,1-2.33,5.83c-2.55,3.07-7,3.62-11,3.87q-10.14.61-20.29.5a278.13,278.13,0,0,1-50.67-5.32c-2.89-.58-6.26-1.61-7.18-4.42a3.48,3.48,0,0,1-.14-.64,9.67,9.67,0,0,1,.36-3.93l9.15-39.17c1.24-5.32,2.52-10.74,5.35-15.41,5.64-9.35,16.36-14.13,26.41-18.36l27.06-11.41c7.4-3.1,12.43-3.5,11.77-12.21-1.45-19.26-5.49-38-5.49-57.44,0-5.58.26-11.35,2.66-16.37s6.71-8.84,11.14-12.2a129.4,129.4,0,0,1,34.95-18.51q3.54,0,7.07.3c16.29,1.26,31.81,6.49,40.09,19.9,4.43,7.16,6,15.66,7.48,23.95.67,3.83,1.34,7.69,2,11.55,1.45,8.77,2.78,17.63,3.85,26.51C821.5,356.84,822,362,822.44,367.23Z",
    transform: "translate(0 0)",
    fill: "#25233a"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M822.44,367.23a117,117,0,0,1-12,45.94,132.11,132.11,0,0,1-8.9,15.09c-6.09,2.59-13.42,2.56-20.21,2.66a227.38,227.38,0,0,0-31.91,2.74c-4.74.74-9.68,1.73-13.4,4.77,0,0,6.21-34.32,31.54-45.88s53.32-40.89,53.32-40.89C821.5,356.84,822,362,822.44,367.23Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M266.53,296.31c-.14-.12-.27-.25-.4-.38l.09.08A1.77,1.77,0,0,1,266.53,296.31Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.45,280.4s1.45,16.09,5.17,20.18a48.09,48.09,0,0,1-10.91-16.53s14.69-107,31.35-126.1l5,2.65Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.47,193.66l.23,11-14.36,36.15-43.88,23h0L412,260.66,455.61,237S469.22,209,472.47,193.66Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.82,280.31l-.74,3.94-49.92-3.72c-13.82-1.19-27.38-10.64-29.1-24.45l-17.23-61a15.56,15.56,0,0,1,3-14.69s16.09,75.5,22,82.26S333,273.46,333,273.46Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.62,398.66l-26.85,84.8-4-1.72,22.91-90.2S259.76,367,253.2,349.09c-6.3-17.17,2.27-51.19,3-53.93l3.43,3.55s-9,40.26,2.58,59.4S276.62,398.66,276.62,398.66Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.25,301h0a39.66,39.66,0,0,1-5.89-2A10.2,10.2,0,0,1,476,285.6v-.15c2.83-6.4,2.91-15.66,2.65-24.2-.59-19.64-5.56-40.87-5.93-49.75-.24-5.65.67-13.66,2.33-21.66l3.14-13.29s-2.88,21.56-3.62,27.47,6,39.56,8.51,44.44-1.89,33.6-1.3,40.42S487.25,301,487.25,301Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.94,479.53l-4.09,2c-.47-2.35-9.22-45.6-21.55-76.94-9.21-23.37-13.65-71-15.38-95.32l5.07,1s7.52,62.1,15.78,85.06S542.94,479.53,542.94,479.53Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.46,257.66,527.2,300.37l-3-.57-.59-.2,12.45-40s-16.3-44.94-19.06-58.78a38.77,38.77,0,0,1-.13-13.88,12,12,0,0,1,9.41-9.77s-9,6.27-6.26,20.13C523.6,215.11,540.46,257.66,540.46,257.66Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "510.15 166.15 489.42 231.91 485.44 235.94 506.46 164.71 506.54 157.58 509.21 160.31 509.21 160.32 510.15 166.15",
    fill: "#fff",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M248.82,480.06l-5.75,10.46,5.78,3.31,2.15-1.72,9.32,8.58s3.33,2.3,11.48,2.3,9.76-1.17,9.76-1.17,0-12-10-11.45-10.69-5.14-10.69-5.14Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M312.44,486.34l-.94,15.46h7V496l9.5,5.8,23.49-.06s0-16-10.56-15.16-14.82,0-14.82,0l-1.67-2.23Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M554.06,479.29l1,15.45h-7V488.9l-9.43,5.86-23.49.06s0-16,10.49-15.21,14.82,0,14.82,0l1.65-2.24Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M477.49,479.48l1,15.44h-7v-5.84L462,495l-23.49.06s0-16,10.49-15.21,14.82,0,14.82,0l1.65-2.24Z",
    transform: "translate(0 0)",
    fill: "#e5c15c"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M248.82,480.06l-5.75,10.46,5.78,3.31,2.15-1.72,9.32,8.58s3.33,2.3,11.48,2.3,9.76-1.17,9.76-1.17,0-12-10-11.45-10.69-5.14-10.69-5.14Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-21)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M312.44,486.34l-.94,15.46h7V496l9.5,5.8,23.49-.06s0-16-10.56-15.16-14.82,0-14.82,0l-1.67-2.23Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-22)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M554.06,479.29l1,15.45h-7V488.9l-9.43,5.86-23.49.06s0-16,10.49-15.21,14.82,0,14.82,0l1.65-2.24Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-23)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M477.49,479.48l1,15.44h-7v-5.84L462,495l-23.49.06s0-16,10.49-15.21,14.82,0,14.82,0l1.65-2.24Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-24)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealHend);
export default __webpack_public_path__ + "static/media/deal-hend.885744bbe07ef79fa6dc1c9bd4d92768.svg";
export { ForwardRef as ReactComponent };